var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('static-fullscreen-card',{attrs:{"title":false}},[_vm._v(" Добро пожаловать в систему повышения вашей квалификации")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }